import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "h2-div"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");
  return _openBlock(), _createElementBlock("h2", _hoisted_1, [_createTextVNode(_toDisplayString($props.title) + " ", 1), $props.more ? (_openBlock(), _createBlock(_component_el_link, {
    key: 0,
    type: "primary",
    class: "link-div",
    href: $props.more
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("历史记录", -1)]))]),
    _: 1
  }, 8, ["href"])) : _createCommentVNode("", true)]);
}